import React, { useMemo } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import "./bootstrap.min.css";

// Components
import DashboardMain from "./components/Dashboard/DashboardMain/DashboardMain";
import DashboardFileManagement from "./components/Dashboard/DashboardFileManagement/DashboardFileManagement";
import CardDetail from "./components/Dashboard/DashboardFileManagement/CardDetail/CardDetail";
import MultipleStoryCard from "./components/Dashboard/DashboardFileManagement/MultipleStoryCard";
import ConsultantReports from "./components/Dashboard/DashboardFileManagement/ConsultantReports/ConsultantReports";
// import AddNewFileMainPage from './components/Dashboard/DashboardAddNewFile/AddNewFileMainPage/AddNewFileMainPage';
import EditCard from "./components/Dashboard/DashboardFileManagement/CardDetail/EditCard/EditCard";
import DashboardArchivedFiles from "./components/Dashboard/DashboardArchivedFiles/DashboardArchivedFiles";
import AllBlogs from "./components/Home/Blogs/AllBlogs/AllBlogs";
import UserFilesDetail from "./components/Home/UserFilesDetail/UserFilesDetail";
import UserFilesToShow from "./components/Home/UserFilesToShow/UserFilesToShow";
import UserFilesToShowRent from "./components/Home/UserFilesToShow/UserFilesToShowRent";
import AddMeeting from "./components/Dashboard/Meeting/AddMeeting/AddMeeting";
import MeetingsArchive from "./components/Dashboard/Meeting/Archive/MeetingsArchive";
import MeetingDetail from "./components/Dashboard/Meeting/MeetingDetail/MeetingDetail";
import MyNotes from "./components/Dashboard/Notes/MyNotes/MyNotes";
import AddNote from "./components/Dashboard/Notes/AddNote/AddNote";
import NoteDetail from "./components/Dashboard/Notes/NoteDetail/NoteDetail";
import ShareToConsultant from "./components/Dashboard/DashboardAddNewFile/ShareToConsultant/ShareToConsultant";
import AddCategory from "./components/Dashboard/DashboardAddNewFile/AddCategory/AddCategory";
import Home from "./components/Home/Home";
import SignUp from "./components/Home/SignUp/SignUp";
import Login from "./components/Home/Login/Login";
import AddBlog from "./components/Dashboard/Blogs/AddBlog/AddBlog";
import BlogDetail from "./components/Home/Blogs/BlogDetail/BlogDetail";
import SeeBlogs from "./components/Dashboard/Blogs/SeeBlogs/SeeBlogs";
import EditBlog from "./components/Dashboard/Blogs/EditBlog/EditBlog";
import ConsultantTextReportsDetails from "./components/Dashboard/DashboardFileManagement/ConsultantReports/ConsultantTextReportsDetails/ConsultantTextReportsDetails";
import ConsultantReportsExpertReportAdd from "./components/Dashboard/DashboardFileManagement/ConsultantReports/ConsultantReportsExpertReportDetails/ConsultantReportsExpertReportAdd";
import ConsultantReportsExpertReportEdit from "./components/Dashboard/DashboardFileManagement/ConsultantReports/ConsultantReportsExpertReportDetails/ConsultantReportsExpertReportEdit";
import ConsultantReportsServiceAdd from "./components/Dashboard/DashboardFileManagement/ConsultantReports/ConsultantReportsServiceDetails/ConsultantReportsServiceAdd";
import ConsultantReportsServiceEdit from "./components/Dashboard/DashboardFileManagement/ConsultantReports/ConsultantReportsServiceDetails/ConsultantReportsServiceEdit";
// import FilesPrivateData from './components/Dashboard/DashboardFileManagement/FilesPrivateData/FilesPrivateData';
import Settings from "./components/Dashboard/Settings/Settings";
import SettingAbout from "./components/Dashboard/Settings/SettingAbout/SettingAbout";
import SettingContact from "./components/Dashboard/Settings/SettingContact/SettingContact";
import SettingContactMessagesDetail from "./components/Dashboard/Settings/SettingContact/SettingContactMessagesDetail";
import StaffColleaguesInfo from "./components/Dashboard/StaffManagment/StaffColleaguesInfo/StaffColleaguesInfo";
import StaffColleaguesInfoNotifDetail from "./components/Dashboard/StaffManagment/StaffColleaguesInfo/StaffColleaguesInfoNotifDetail";
import StaffColleaguesInfoNotifDetailInfo from "./components/Dashboard/StaffManagment/StaffColleaguesInfo/StaffColleaguesInfoNotifDetailInfo";
import StaffColleaguesInfoCardDetail from "./components/Dashboard/StaffManagment/StaffColleaguesInfo/StaffColleaguesInfoCardDetail";
import StaffDataStatistic from "./components/Dashboard/StaffManagment/StaffDataStatistic/StaffDataStatistic";
import StaffActivity from "./components/Dashboard/StaffManagment/StaffActivity/StaffActivity";
import StaffActivityCardDetail from "./components/Dashboard/StaffManagment/StaffActivity/StaffActivityCardDetail";
import StaffMessage from "./components/Dashboard/StaffManagment/StaffMessage/StaffMessage";
import StaffSupport from "./components/Dashboard/StaffManagment/StaffSupport/StaffSupport";
import StaffSupportMessageSend from "./components/Dashboard/StaffManagment/StaffSupport/StaffSupportMessageSend";
import StaffSupportCardDetail from "./components/Dashboard/StaffManagment/StaffSupport/StaffSupportCardDetail";
import StaffSupportMessageDetail from "./components/Dashboard/StaffManagment/StaffSupport/StaffSupportMessageDetail";
import StaffFinancialDepartment from "./components/Dashboard/StaffManagment/StaffFinancialDepartment/StaffFinancialDepartment";
import StaffFinancialRequestDetail from "./components/Dashboard/StaffManagment/StaffFinancialDepartment/StaffFinancialRequestDetail";
import UserManagmentInfo from "./components/Dashboard/UserManagment/UserInfo/UserManagmentInfo";
import UserManagmentInfoDetail from "./components/Dashboard/UserManagment/UserInfo/UserManagmentInfoDetail";
import UserManagmentChat from "./components/Dashboard/UserManagment/UserChat/UserManagmentChat";
import UserManagmentChatStart from "./components/Dashboard/UserManagment/UserChat/UserManagmentChatStart";
import UserManagmentChatDetail from "./components/Dashboard/UserManagment/UserChat/UserManagmentChatDetail";
import Notification from "./components/Dashboard/Notif/Notification";
import MyAccount from "./components/Dashboard/Profile/MyAccount";
import Aboutus from "./components/Home/Aboutus/Aboutus";
import ContactUsPage from "./components/Home/ContactUsPage/ContactUsPage";
import Consultant from "./components/Home/Consultant/Consultant";
import SavedFiles from "./components/Dashboard/SavedFiles/SavedFiles";
import UserMyAds from "./components/UserDashboard/UserMyAds/UserMyAds";
import UserMyAdsDetail from "./components/UserDashboard/UserMyAds/UserMyAdsDetail/UserMyAdsDetail";
import UserAddNewFile from "./components/UserDashboard/UserAddNewFile/UserAddNewFile";
import ConsultantSignupForm from "./components/Home/Consultant/ConsultantSignup/ConsultantSignupForm/ConsultantSignupForm";
import Reminders from "./components/Dashboard/Reminders/Reminders";
import UserMyNotes from "./components/UserDashboard/UserNotes/UserMyNotes/UserMyNotes";
import UserAddNote from "./components/UserDashboard/UserNotes/UserAddNote/UserAddNote";
import UserNoteDetail from "./components/UserDashboard/UserNotes/UserNoteDetail/UserNoteDetail";
import UserSavedFiles from "./components/UserDashboard/UserSavedFiles/UserSavedFiles";
import UserMyReminders from "./components/UserDashboard/UserMyReminders/UserMyReminders";
import UserProfile from "./components/UserDashboard/UserProfile/UserProfile";
import UserRequestFile from "./components/UserDashboard/UserRequestFile/UserRequestFile";
import AddRequest from "./components/UserDashboard/UserRequestFile/AddRequest/AddRequest";
import ConsultantFinancial from "./components/Dashboard/ConsultantFinancial/ConsultantFinancial";
import UserChats from "./components/UserDashboard/UserChats/UserChats";
import UserChatDetail from "./components/UserDashboard/UserChats/UserChatDetail";
import RequestedFiles from "./components/Dashboard/UserManagment/RequestedFiles/RequestedFiles";
import RequestedFilesDetail from "./components/Dashboard/UserManagment/RequestedFiles/RequestedFilesDetail";
import RequestDetail from "./components/UserDashboard/UserRequestFile/RequestDetail/RequestDetail";
import BlogDetailManagment from "./components/Dashboard/Blogs/BlogDetailManagment/BlogDetailManagment";
import DashboardFileManagementUsers from "./components/Dashboard/DashboardFileManagement/DashboardFileManagementUsers";
import UserNotifications from "./components/UserDashboard/UserNotifications/UserNotifications";
import EditFile from "./components/UserDashboard/UserMyAds/EditFile/EditFile";
import Messages from "./components/Dashboard/Messages/Messages";
import AddRequestFileManagment from "./components/Dashboard/RequestFile/AddRequestFileManagment";
import ScrollToTop from "./ScrollToTop";

// context
import UserContextProvider from "./components/Context/UserContextProvider";
import AddMultipleFile from "./components/Dashboard/DashboardFileManagement/CardDetail/AddMultipleFile";
import SecondBanner from "./components/Dashboard/Settings/SecondBanner/SecondBanner";
import FirstBanner from "./components/Dashboard/Settings/FirstBanner/FirstBanner";
import SelectCategory from "./components/Dashboard/DashboardAddNewFile/SelectCategory/SelectCategory";
import PlacesFiles from "./components/Dashboard/PlacesFiles/PlacesFiles";
import Hiring from "./components/Home/Hiring/Hiring";
import CommissionCalculation from "./components/Home/CommissionCalculation/CommissionCalculation";
import Landing from "./components/Home/Landing/Landing";
import AddNewFileRegion from "./components/Dashboard/DashboardReuseAbleComponents/AddNewFiles/AddNewFileRegion";
import EditCardRegion from "./components/Dashboard/DashboardFileManagement/CardDetail/EditCard/EditCardRegion";
import DashboardCategoriesManagement from "./components/Dashboard/DashboardCategoriesManagement/DashboardCategoriesManegement";
import ArchiveRequests from "./components/Dashboard/ArchiveRequests/ArchiveRequests";
import EditCardCategory from "./components/Dashboard/DashboardFileManagement/CardDetail/EditCard/EditCardCategory/EditCardCategory";
import LandingManagement from "./components/Dashboard/LandingManagement/LandingManagement";
import Landings from "./components/Home/Landings/Landings";
import LandingDescriptionManagement from "./components/Dashboard/LandingDescriptionManagement/LandingDescriptionManagement";

function App() {
  const userData = useMemo(() => {
    // function to create the value
    const user = localStorage.getItem("userData");
    return JSON.parse(user);
    // dependencies array
  }, []);
  const permissions = userData && [].concat(...userData?.roles?.map(role => role?.permissions));
  // const permissions = userData?.roles[0]?.permissions;

  return (
    <>
      <UserContextProvider>
        <ScrollToTop />
        <Switch>
          <ProtectedRoute path="/add-multiple/:id" component={AddMultipleFile} isAuth={true} />
          <ProtectedRoute path="/add-request-file" component={AddRequestFileManagment} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/my-messages" component={Messages} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/blog-dashboard-detail/:id" component={BlogDetailManagment} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-notifications" component={UserNotifications} isAuth={userData === null ? false : true} />
          <ProtectedRoute
            path="/consultant-financial-dep"
            component={ConsultantFinancial}
            isAuth={
              permissions?.find(item => item === 14) === 14 || permissions?.find(item => item === 19) === 19 || permissions?.find(item => item === 15) === 15
                ? false
                : true
            }
          />
          <ProtectedRoute path="/user-chat-detail/:id" component={UserChatDetail} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/chats" component={UserChats} isAuth={userData === null && localStorage.getItem("userToken") != null ? false : true} />
          <ProtectedRoute path="/user-request-file-detail/:id" component={RequestDetail} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-add-request-file" component={AddRequest} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-request-file" component={UserRequestFile} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-profile" component={UserProfile} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-my-reminders" component={UserMyReminders} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-saved-files" component={UserSavedFiles} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-note-detail/:id" component={UserNoteDetail} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-add-note" component={UserAddNote} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-my-notes" component={UserMyNotes} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-edit-file/:id" component={EditFile} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-add-new-file" component={UserAddNewFile} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-files-detail/:id" component={UserMyAdsDetail} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/user-files" component={UserMyAds} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/share-to-consultant/:id" component={ShareToConsultant} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/note-detail/:id" component={NoteDetail} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/add-note" component={AddNote} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/my-notes" component={MyNotes} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/reminders" component={Reminders} isAuth={userData === null ? false : true} />
          <ProtectedRoute
            path="/add-meeting"
            component={AddMeeting}
            isAuth={
              permissions?.find(item => item === 9) === 9 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/meeting-archive"
            component={MeetingsArchive}
            isAuth={
              permissions?.find(item => item === 8) === 8 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 19) === 19 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/meeting-info/:id"
            component={MeetingDetail}
            isAuth={
              permissions?.find(item => item === 10) === 10 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 19) === 19 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/categories-management"
            component={DashboardCategoriesManagement}
            isAuth={
              permissions?.find(item => item === 10) === 10 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 19) === 19 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/landing-management"
            component={LandingManagement}
            isAuth={
              permissions?.find(item => item === 10) === 10 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 19) === 19 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/landing-description-management"
            component={LandingDescriptionManagement}
            isAuth={
              permissions?.find(item => item === 10) === 10 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 19) === 19 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/archive-requests"
            component={ArchiveRequests}
            isAuth={
              permissions?.find(item => item === 10) === 10 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 19) === 19 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />

          <ProtectedRoute
            path="/add-new-file"
            component={SelectCategory}
            isAuth={
              permissions?.find(item => item === 2) === 2 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 18) === 18
                ? true
                : false
            }
          />

          <ProtectedRoute
            path="/add-new-file-region"
            component={AddNewFileRegion}
            isAuth={
              permissions?.find(item => item === 2) === 2 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 18) === 18
                ? true
                : false
            }
          />

          <ProtectedRoute path="/add-category" component={AddCategory} isAuth={userData === null ? false : true} />
          {/* <ProtectedRoute path="/select-category" component={SelectCategory} isAuth={userData === null ? false : true} /> */}

          <ProtectedRoute path="/consultant-reports/:id" component={ConsultantReports} isAuth={userData === null ? false : true} />

          <ProtectedRoute path="/consultant-text-reports/:id" component={ConsultantTextReportsDetails} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/consultant-area-files" component={PlacesFiles} isAuth={userData === null ? false : true} />
          <ProtectedRoute
            path="/add-consultant-reports-expert-report/:id"
            component={ConsultantReportsExpertReportAdd}
            isAuth={userData === null ? false : true}
          />
          <ProtectedRoute
            path="/consultant-reports-expert-report/:id"
            component={ConsultantReportsExpertReportEdit}
            isAuth={userData === null ? false : true}
          />
          <ProtectedRoute path="/add-consultant-reports-service/:id" component={ConsultantReportsServiceAdd} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/edit-consultant-reports-service/:id" component={ConsultantReportsServiceEdit} isAuth={userData === null ? false : true} />
          {/* <ProtectedRoute path="/files-private-data" component={FilesPrivateData} isAuth={userData === null ? false : true} /> */}
          <ProtectedRoute path="/multiple-story-cards" component={MultipleStoryCard} isAuth={userData === null ? false : true} />

          <ProtectedRoute
            path="/edit-card/:id"
            component={EditCard}
            isAuth={
              permissions?.find(item => item === 3) === 3 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 19) === 19 ||
              permissions?.find(item => item === 18) === 18 ||
              permissions?.find(item => item === 19) === 19 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />
          <ProtectedRoute path="/edit-card-category/:id" component={EditCardCategory} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/edit-card-region/:id" component={EditCardRegion} isAuth={userData === null ? false : true} />

          <ProtectedRoute path="/card-detail/:id" component={CardDetail} isAuth={userData === null ? false : true} />

          <ProtectedRoute
            path="/FileManagement"
            component={DashboardFileManagement}
            isAuth={
              permissions?.find(item => item === 1) === 1 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 18) === 18 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />

          <ProtectedRoute
            path="/fileManagement-users"
            component={DashboardFileManagementUsers}
            isAuth={permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 18) === 18 ? true : false}
          />
          <ProtectedRoute
            path="/saved-files"
            component={SavedFiles}
            isAuth={
              permissions?.find(item => item === 4) === 4 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 18) === 18 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />

          <ProtectedRoute
            path="/archive-files"
            component={DashboardArchivedFiles}
            isAuth={
              permissions?.find(item => item === 5) === 5 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 18) === 18 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />

          <ProtectedRoute
            path="/DashboardMain"
            component={DashboardMain}
            isAuth={
              permissions?.find(item => item === 0) === 0 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 18) === 18
                ? true
                : false
            }
          />

          <ProtectedRoute path="/my-account" component={MyAccount} isAuth={userData === null ? false : true} />
          <ProtectedRoute
            path="/staff-managment-colleagues-info"
            component={StaffColleaguesInfo}
            isAuth={
              permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/staff-managment-colleagues-info-notif-detail"
            component={StaffColleaguesInfoNotifDetail}
            isAuth={permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 ? true : false}
          />
          <ProtectedRoute
            path="/staff-managment-colleagues-info-notif-detail-info/:id"
            component={StaffColleaguesInfoNotifDetailInfo}
            isAuth={permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 ? true : false}
          />
          <ProtectedRoute
            path="/staff-managment-colleagues-info-card-detail/:id"
            component={StaffColleaguesInfoCardDetail}
            isAuth={
              permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/staff-managment-statistics"
            component={StaffDataStatistic}
            isAuth={
              permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/staff-managment-activity"
            component={StaffActivity}
            isAuth={
              permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/staff-managment-activity-card-detail/:id"
            component={StaffActivityCardDetail}
            isAuth={
              permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/staff-managment-message"
            component={StaffMessage}
            isAuth={
              permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/staff-managment-support"
            component={StaffSupport}
            isAuth={
              permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/staff-managment-support-send-message"
            component={StaffSupportMessageSend}
            isAuth={
              permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/staff-managment-support-card-detail/:id"
            component={StaffSupportCardDetail}
            isAuth={
              permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/staff-managment-support-message-detail/:id"
            component={StaffSupportMessageDetail}
            isAuth={
              permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/staff-managment-financial-dep"
            component={StaffFinancialDepartment}
            isAuth={permissions?.find(item => item === 6) === 6 ? true : false}
          />
          <ProtectedRoute
            path="/staff-managment-financial-request-detail"
            component={StaffFinancialRequestDetail}
            isAuth={permissions?.find(item => item === 6) === 6 || permissions?.find(item => item === 15) === 15 ? true : false}
          />
          <ProtectedRoute
            path="/user-managment-info"
            component={UserManagmentInfo}
            isAuth={
              permissions?.find(item => item === 7) === 7 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 18) === 18
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/requested-file/:id"
            component={RequestedFilesDetail}
            isAuth={
              permissions?.find(item => item === 7) === 7 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 18) === 18 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/requested-files"
            component={RequestedFiles}
            isAuth={
              permissions?.find(item => item === 7) === 7 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 18) === 18 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/user-managment-info-detail/:id"
            component={UserManagmentInfoDetail}
            isAuth={
              permissions?.find(item => item === 7) === 7 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 18) === 18 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/user-managment-chat"
            component={UserManagmentChat}
            isAuth={
              permissions?.find(item => item === 7) === 7 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 18) === 18 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/user-managment-chat-start"
            component={UserManagmentChatStart}
            isAuth={
              permissions?.find(item => item === 7) === 7 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 18) === 18 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/user-managment-chat-detail/:id"
            component={UserManagmentChatDetail}
            isAuth={
              permissions?.find(item => item === 7) === 7 ||
              permissions?.find(item => item === 15) === 15 ||
              permissions?.find(item => item === 18) === 18 ||
              permissions?.find(item => item === 16) === 16
                ? true
                : false
            }
          />

          <ProtectedRoute path="/notification" component={Notification} isAuth={userData === null ? false : true} />
          <ProtectedRoute path="/banner-1" component={FirstBanner} isAuth={permissions?.find(item => item === 15) === 15 ? true : false} />
          <ProtectedRoute path="/banner-2" component={SecondBanner} isAuth={permissions?.find(item => item === 15) === 15 ? true : false} />
          <ProtectedRoute path="/setting-about" component={SettingAbout} isAuth={permissions?.find(item => item === 15) === 15 ? true : false} />
          <ProtectedRoute path="/setting-contact" component={SettingContact} isAuth={permissions?.find(item => item === 15) === 15 ? true : false} />
          <ProtectedRoute
            path="/setting-contact-messages-detail/:id"
            component={SettingContactMessagesDetail}
            isAuth={permissions?.find(item => item === 15) === 15 ? true : false}
          />
          <ProtectedRoute path="/settings" component={Settings} isAuth={permissions?.find(item => item === 15) === 15 ? true : false} />
          <ProtectedRoute
            path="/add-blog"
            component={AddBlog}
            isAuth={
              permissions?.find(item => item === 12) === 12 || permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19
                ? true
                : false
            }
          />
          <ProtectedRoute
            path="/edit-blog/:id"
            component={EditBlog}
            isAuth={permissions?.find(item => item === 13) === 13 || permissions?.find(item => item === 15) === 15 ? true : false}
          />
          <ProtectedRoute
            path="/blog-dashboard"
            component={SeeBlogs}
            isAuth={permissions?.find(item => item === 11) === 11 || permissions?.find(item => item === 15) === 15 ? true : false}
          />
          <ProtectedRoute path="/consultant-signup" component={ConsultantSignupForm} isAuth={true} />
          <ProtectedRoute path="/مشاور-ما-شوید" component={Consultant} isAuth={true} />
          <ProtectedRoute path="/تماس-با-ما" component={ContactUsPage} isAuth={true} />
          <ProtectedRoute path="/درباره-ما" component={Aboutus} isAuth={true} />
          <Route exact path="/وبلاگ/:id" component={BlogDetail} />
          <ProtectedRoute path="/وبلاگ" component={AllBlogs} isAuth={true} />
          <Route exact path="/لندینگ/:link" component={Landings} />
          <Route exact path="/همکاری-با-ما" component={Hiring} />
          <Route exact path="/خرید-خارج-از-کشور" component={Landing} />
          <Route exact path="/محاسبه-آنلاین-کمیسیون" component={CommissionCalculation} />
          <Route exact path="/فایل/:id" component={UserFilesDetail} />
          <Route exact path="/فایل-ها/:deal/:use/:property/:region" component={UserFilesToShow} />
          <Route exact path="/فایل-ها/:deal/:use/:property" component={UserFilesToShow} />
          <Route exact path="/فایل-ها/:deal/:use" component={UserFilesToShow} />
          <Route exact path="/فایل-ها/:deal" component={UserFilesToShow} />
          {/*<Route exact path="/رهن-و-اجاره" component={UserFilesToShowRent} />*/}
          <ProtectedRoute path="/ورود" component={Login} isAuth={userData === null ? true : ""} />
          <ProtectedRoute path="/ثبت-نام" component={SignUp} isAuth={userData === null ? true : ""} />
          <ProtectedRoute path="/:deal" component={Home} isAuth={true} />
          <ProtectedRoute path="/" component={Home} isAuth={true} />
          <Redirect to="/" />
        </Switch>
      </UserContextProvider>
    </>
  );
}

export default App;
